
import { LinkItem } from "Interfaces/general.interface"
import Consts from "Interfaces/Consts";
import Helper from "Interfaces/Helper";

type Props = {
    link: LinkItem;
    isBtn: boolean;
    title?: string;
    pageUrl?: string;
    btnClass?: string;
    linkClass?: string;
    linkIcon?: boolean;
    charLimit?: number;
    extraAriaContext?: string;
    dir?: string;
    linkTarget?: string;
};

const CustomLinkButton: React.FC<Props> = (props) => {

    const { title, pageUrl, isBtn, btnClass, linkClass, extraAriaContext, linkTarget } = props;
    const isrtl = props.dir == "rtl";
    const addIcon = props.linkIcon;
    const charLimit = gatCharLimit(props.charLimit);
    const { link, linkTitle } = getLink(props.link, pageUrl);
    const isFile = checkIsFile(link.url);
    const linkIconType = `fa-chevron-${isFile ? 'down' : (isrtl ? 'left' : 'right')}`;
    const dispTitle = linkTitle || link.title;
    const extraDispTitle = extraAriaContext || '';

    const buttonAttrs = {
        href: link.url,
        target: linkTarget ? linkTarget : link.target,
        title//: extraDispTitle.replace(/&quot;/g, '"') + ' ' + dispTitle
    }


    function getLink(propsLink: LinkItem, pageUrl?: string) {
        let linkTitle = "";
        const link = { ...propsLink };

        if (pageUrl) {
            //link to page
            link.url = pageUrl;
            link.title = Consts.moreInfo;
            linkTitle = `${Consts.moreInfoAbout} ${title}`;
        }
        else if (link && link.url) {
            //simple link
            link.title = link.title ? link.title : title;
            if (link.target) {
                linkTitle = `${link.title}  ${Consts.openInNewWindow}`;
            }
        }

        return {
            link,
            linkTitle
        }
    }

    function checkIsLink(linkUrl: string) {

        const LINK_START_OPTIONS = ["/", "http", "mailto:", "tel:"];

        for (let i = 0; i < LINK_START_OPTIONS.length; i++) {
            if (linkUrl.startsWith(LINK_START_OPTIONS[i])) {
                return true;
            }
        }
        return false;
    }

    function checkIsFile(linkUrl: string): boolean {
        const SUPPORTED_FILES = [".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".txt", ".ics", ".pps", ".ppsx", ".json", ".zip"];
        const linkExtention = linkUrl.split('.')[1];
        if (linkExtention) {
            const linkExtensionWithoutQuerystring = linkExtention.split('?')[0];
            return SUPPORTED_FILES.indexOf("." + linkExtensionWithoutQuerystring) !== -1;
        }
        return false;
    }

    function gatCharLimit(propsCharLimit?: number) {
        const charLimit = propsCharLimit != undefined ? propsCharLimit : 20;
        const DefaultLimit = 20;
        const defaultArabicLimit = 25;
        const isArabLang = document.documentElement.lang == "ar";
        if (isArabLang && charLimit == DefaultLimit) {
            return defaultArabicLimit;
        }
        return charLimit;
    }


    if (!link || !link.url) return null;

    
    if (!checkIsLink(link.url)) { //display only title if there no link
        return <SimpleButton charLimit={charLimit} linkTitle={link.title} />
    }

    if (link.url.startsWith("tel:")) {
        return (
            <TelLinkBtn
                wrapperClass={isBtn ? btnClass : linkClass}
                icon={linkIconType}
                link={link}
                charLimit={charLimit}
                hasIcon={addIcon} />
        )
    }

    return (
        <DefaultLinkBtn
            buttonAttrs={buttonAttrs}
            isFile={isFile}
            wrapperClass={isBtn ? btnClass : linkClass}
            icon={linkIconType}
            link={link}
            charLimit={charLimit}
            hasIcon={addIcon} />
    );

}

const SimpleButton = ({ charLimit, linkTitle }: { charLimit: number, linkTitle: string }) => {
    return (
        <div className="mst-miner-title">
            { charLimit > 0 && Helper.substringEx(linkTitle, charLimit) }
            { charLimit < 0 && linkTitle.substring(-3) }
        </div>
    );
}

type LinkBtnProps = {
    buttonAttrs?: {
        href: string;
        target: string;
        title: string;
    },
    icon: string;
    wrapperClass: string;
    link: LinkItem;
    charLimit: number;
    hasIcon: boolean;
    isFile?: boolean;
    linkTarget?: string;
}

const TelLinkBtn = ({ wrapperClass, link, charLimit, hasIcon, icon }: LinkBtnProps) => {
    return (
        <a className={` mst-phone-link  ${wrapperClass}`}
            href={`${link.url}`} aria-label={`${link.url.split(":")[1]} ${Consts.callPhoneNumber}`}>
            { charLimit > 0 && Helper.substringEx(link.title, charLimit) }
            { hasIcon && <i className={`fa fa-fw ${icon}`} aria-hidden="true"></i> }
        </a>
    )
}

const DefaultLinkBtn = ({ wrapperClass, buttonAttrs, isFile, link, charLimit, hasIcon, icon }: LinkBtnProps) => {
    return (
        <a className={`${wrapperClass} `} {...buttonAttrs} {...(isFile ? { 'download': link.url } : {})} >

            { charLimit > 0 && Helper.substringEx(link.title, charLimit) }

            { charLimit < 0 && link.title.substring(-3) }

            {hasIcon && <i className={`fa fa-fw ${icon} `} aria-hidden="true"></i>}

        </a>
    )
}

export default CustomLinkButton;
